
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class IndexPriceDialog extends SiteEntityDialog<IndexPriceRow, any> {
        protected getFormKey() { return IndexPriceForm.formKey; }
        protected getIdProperty() { return IndexPriceRow.idProperty; }
        protected getLocalTextPrefix() { return IndexPriceRow.localTextPrefix; }
        protected getService() { return IndexPriceService.baseUrl; }
        protected getDeletePermission() { return IndexPriceRow.deletePermission; }
        protected getInsertPermission() { return IndexPriceRow.insertPermission; }
        protected getUpdatePermission() { return IndexPriceRow.updatePermission; }

        protected form = new IndexPriceForm(this.idPrefix);

    }
}